import React from 'react'

const Placement = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Placement Announcements </h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
      style={{ textAlign: "justify" }}
    >
      <p>None.</p>
    </div>
    </div>
  )
}

export default Placement
